

const MovementReducer = (state, action) => {
    switch (action.type) {
        case "GET_MOVEMENTS_START":
            return {
                ...state,
                movements: [],
                isFetching: true,
                error: false,
            };
        case "GET_MOVEMENTS_SUCCESS":
            return {
                ...state,
                movements: action.payload.movements,
                count: action.payload.count,
                isFetching: false,
                error: false,
            };
        case "GET_MOVEMENTS_FAILURE":
            return {
                ...state,
                movements: [],
                isFetching: false,
                error: action.payload,
            };
        case "ADD_MOVEMENT_START":
            return {
                ...state,
                movement: {},
                isFetchingAdd: true,
                errorAdd: false,
            };
        case "ADD_MOVEMENT_SUCCESS":
            return {
                ...state,
                movement: action.payload.movement,
                isFetchingAdd: false,
                errorAdd: false,
            };
        case "ADD_MOVEMENT_FAILURE":
            return {
                ...state,
                movement: {},
                isFetchingAdd: false,
                errorAdd: action.payload,
            };
        case "LOAD_DECHARGE_START":
            return {
                ...state,
                envoisMovement: [],
                isFetchingLoad: true,
                errorLoad: false,
            };
        case "LOAD_DECHARGE_SUCCESS":
            return {
                ...state,
                envoisMovement: action.payload.envoisMovement,
                count: action.payload.count,
                countGlobal: action.payload.countGlobal,
                sumMontant: action.payload.sumMontant,
                isFetchingLoad: false,
                errorLoad: false,
            };
        case "LOAD_DECHARGE_FAILURE":
            return {
                ...state,
                envoisMovement: [],
                isFetchingLoad: false,
                errorLoad: action.payload,
            };
        ////////////////////////////// Submit Client/Entreprise Decharge //////////////////////////////
        case "SUBMIT_DECHARGE_START":
            return {
                ...state,
                message: "",
                isFetchingSubmit: true,
                errorSubmit: false,
            };
        case "SUBMIT_DECHARGE_SUCCESS":
            return {
                ...state,
                message: action.payload.message,
                isFetchingSubmit: false,
                errorSubmit: false,
            };
        case "SUBMIT_DECHARGE_FAILURE":
            return {
                ...state,
                message: "",
                isFetchingSubmit: false,
                errorSubmit: action.payload,
            };
        case "GET_MOVEMENT_DECHARGE_START":
            return {
                ...state,
                movementDecharge: {},
                envoisDecharge: [],
                isFetchingGetDecharge: true,
                errorGetDecharge: false,
            };
        case "GET_MOVEMENT_DECHARGE_SUCCESS":
            return {
                ...state,
                movementDecharge: action.payload.movement,
                envoisDecharge: action.payload.envois,
                count: action.payload.count,
                countGlobal: action.payload.countGlobal,
                isFetchingGetDecharge: false,
                errorGetDecharge: false,
            };
        case "GET_MOVEMENT_DECHARGE_FAILURE":
            return {
                ...state,
                movementDecharge: {},
                envoisDecharge: [],
                isFetchingGetDecharge: false,
                errorGetDecharge: action.payload,
            };
        case "UPDATE_MOVEMENT_DECHARGE_START":
            return {
                ...state,
                message: "",
                isFetchingUpdate: true,
                errorUpdate: false,
            };
        case "UPDATE_MOVEMENT_DECHARGE_SUCCESS":
            return {
                ...state,
                message: action.payload.message,
                isFetchingUpdate: false,
                errorUpdate: false,
            };
        case "UPDATE_MOVEMENT_DECHARGE_FAILURE":
            return {
                ...state,
                message: "",
                isFetchingUpdate: false,
                errorUpdate: action.payload,
            };
        ////////////////////////////// Submit Retour/Autre Decharge //////////////////////////////
        case "SUBMIT_RETOUR_AUTRE_DECHARGE_START":
            return {
                ...state,
                message: "",
                isFetchingRetourAutreSubmit: true,
                errorRetourAutreSubmit: false,
            };
        case "SUBMIT_RETOUR_AUTRE_DECHARGE_SUCCESS":
            return {
                ...state,
                message: action.payload.message,
                isFetchingRetourAutreSubmit: false,
                errorRetourAutreSubmit: false,
            };
        case "SUBMIT_RETOUR_AUTRE_DECHARGE_FAILURE":
            return {
                ...state,
                message: "",
                isFetchingRetourAutreSubmit: false,
                errorRetourAutreSubmit: action.payload,
            };
        case "GET_RETOUR_AUTRE_DECHARGE_START":
            return {
                ...state,
                movementDecharge: {},
                isFetchingGetDecharge: true,
                errorGetDecharge: false,
            };
        case "GET_RETOUR_AUTRE_DECHARGE_SUCCESS":
            return {
                ...state,
                movementDecharge: action.payload.movement,
                isFetchingGetDecharge: false,
                errorGetDecharge: false,
            };
        case "GET_RETOUR_AUTRE_DECHARGE_FAILURE":
            return {
                ...state,
                movementDecharge: {},
                isFetchingGetDecharge: false,
                errorGetDecharge: action.payload,
            };
        ////////////////////////////// Encaissement //////////////////////////////
        case "GET_MOVEMENT_ENCAISSEMENT_START":
            return {
                ...state,
                movementEncaissement: {},
                envoisEncaissement: [],
                isFetchingGetEncaissement: true,
                errorGetEncaissement: false,
            };
        case "GET_MOVEMENT_ENCAISSEMENT_SUCCESS":
            return {
                ...state,
                movementEncaissement: action.payload.movement,
                envoisEncaissement: action.payload.envois,
                count: action.payload.count,
                isFetchingGetEncaissement: false,
                errorGetEncaissement: false,
            };
        case "GET_MOVEMENT_ENCAISSEMENT_FAILURE":
            return {
                ...state,
                movementEncaissement: {},
                envoisEncaissement: [],
                isFetchingGetEncaissement: false,
                errorGetEncaissement: action.payload,
            };
        case "CLEAR_MOVEMENT":
            return {
                ...state,
                movement: {},
                isFetchingAdd: false,
                errorAdd: false,
                envoisMovement: [],
                movementDecharge: {},
                envoisDecharge: [],
                countGlobal: 0,
                sumMontant: 0,
                isFetchingLoad: false,
                errorLoad: false,
                message: "",
                isFetchingSubmit: false,
                errorSubmit: false,
                isFetchingGetDecharge: false,
                errorGetDecharge: false,
                isFetchingRetourAutreSubmit: false,
                errorRetourAutreSubmit: false,
            };
        default:
            return { ...state };
    }
}

export default MovementReducer;